import React, { useContext } from 'react'
import loadable from '@loadable/component'
import styles from './index.module.less'

export interface AsyncConfig {
  process?: React.FC
  fallback?: React.FC
}

const AsyncConfigContext = React.createContext<AsyncConfig>({
  process: null,
  fallback: null,
})

const Fallback: React.FC = React.memo(() => {
  const { fallback: Component } = useContext(AsyncConfigContext)
  return <Component />
})

Fallback.displayName = 'Fallback'

const Loading: React.FC = React.memo(() => {
  return (
    <div className={styles.loadingBox}>
      <div className={styles.bar}></div>
    </div>
  )
})

Loading.displayName = 'Loading'

const fallback = (error: Error) => () => {
  Promise.reject(error)
  return Fallback ? <Fallback /> : null
}

export function withAsync(component: () => Promise<React.FC | { default: React.FC }>) {
  const fn = () => component().catch(fallback)
  return loadable(fn, { fallback: <Loading /> })
}

export const { Provider: AsyncProvider } = AsyncConfigContext
